import { allowedBehaviouralEvents } from '@web-platform/shared-universal-constants/src/allowedBehaviouralEvents';
import * as minievent from '@web-platform/shared-universal-tracking/src/miniEvents';
import { cleanEmpty } from '@web-platform/shared-universal-utils-frontend/src/helpers/cleanEmpty';
import { logWarn } from '@web-platform/shared-universal-utils-frontend/src/helpers/logger';
import { isInArray } from '@web-platform/shared-universal-utils-universal/src/is-in-array/is-in-array';

import {
  BehaviouralEvent,
  BEHAVIOURAL_EVENT_NAMESPACE,
  BEHAVIOURAL_EVENT_SCHEMA,
} from './BehaviouralEvent';

export type BehaviouralEventProperties = {
  properties?: Record<string, string | undefined>;
  numericProperties?: Record<string, number | undefined>;
  booleanProperties?: Record<string, boolean | undefined>;
};

export function trackBehaviouralEvent(name: string, allProperties: BehaviouralEventProperties) {
  if (!isInArray(name, allowedBehaviouralEvents)) {
    logWarn({
      component: 'trackBehaviouralEvent',
      message: `No new behavioural events are permitted. Event '${name}' added but will not be tracked`,
    });
    return;
  }
  minievent.track(
    BEHAVIOURAL_EVENT_NAMESPACE,
    BEHAVIOURAL_EVENT_SCHEMA,
    BehaviouralEvent(name, cleanEmpty(allProperties)),
  );
}
